// extracted by mini-css-extract-plugin
export default {"burguerMenu":"HamburguerBtn_burguerMenu__w5lFi","burguer":"HamburguerBtn_burguer__nBuaw","clicked":"HamburguerBtn_clicked__kLiqj"};